import linkifyHtml from 'linkify-html';

const TextAsset = ({title, text}) => {
  // The text here is html prepared by our rich-text editor component.
  // It has been run through the 'clean_asset_tags' filter on the server before it gets here
  // It needs to get rendered as-is. (a valid use of dangerouslySetInnerHTML)
  const textMarkup = linkifyHtml(text);
  // biome-ignore lint/style/useNamingConvention: allow html
  const getTextMarkup = () => ({__html: textMarkup});
  return (
    <div className="premium_text_insert">
      <div className="card-base text portrait">
        <h2 className="card-subheader" style={{textAlign: 'center'}}>
          {title}
        </h2>
        {/** biome-ignore lint/security/noDangerouslySetInnerHtml: allow html */}
        <div className="body" dangerouslySetInnerHTML={getTextMarkup()} />
      </div>
    </div>
  );
};

const PhotoAsset = ({imageKey}) => (
  <div className="premium_photo_insert">
    <div className="premium_photo_insert__wrapper">
      <img
        className="premium_photo_insert__photo"
        src={`/services/images/${imageKey}/s0`}
        alt="invite"
      />
    </div>
  </div>
);

export const PremiumInsert = ({insert}) => {
  if (insert.card_type === 'text') return <TextAsset title={insert.title} text={insert.text} />;
  if (insert.card_type === 'photo')
    return <PhotoAsset title={insert.title} imageKey={insert.image_key} />;
  evite.log('Unknown card_type', insert.card_type);
  return null;
};
